// set basepath of project for webpack
import { basePath } from './core/config';

__webpack_public_path__ = `${ basePath }js/`;

import 'console-polyfill';
import elementClosestPolyfill from 'element-closest';

elementClosestPolyfill(window);

// import { queryAll } from './utils/dom'
// import EventBus from './core/EventBus'

import { loadComponents } from './core/componentUtils';

loadComponents();

/**
 * lazy loading
 */
import lazySizes from 'lazysizes';

lazySizes.cfg.lazyClass = 'is-lazy';
lazySizes.cfg.loadingClass = 'is-lazy-loading';
lazySizes.cfg.loadedClass = 'is-lazy-loaded';


import inView from 'in-view';
import loadTippy from './Tippy';


if (window.innerWidth >= 1024) {
    inView.threshold(.7);
} else {
    inView.threshold(.5);
}

inView('[data-seen]')
    .on('enter', (element) => {
        element.classList.add('seen');
        element.classList.add('is-in-view');
        element.dispatchEvent(new CustomEvent('enteredView'));
    })
    .on('exit', (element) => {
        element.classList.remove('is-in-view');
        element.dispatchEvent(new CustomEvent('leftView'));
    });

loadTippy();

